import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

export const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title,
  description,
  isLoading = false 
}) => {
  const { t } = useLanguage();

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">
            {title || t('confirm')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description || t('confirmDelete')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            className="rounded-full"
            data-testid="confirm-cancel-btn"
          >
            {t('cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="rounded-full bg-destructive hover:bg-destructive/90"
            data-testid="confirm-action-btn"
          >
            {isLoading ? t('loading') : t('delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
